<script>
import ContentLogin from "@/components/devise/Login.vue";
import FloatingLabel from "@/components/FloatingLabel";
import PencilIcon from "vue-material-design-icons/Pencil.vue";

export default {
  name: "login",
  data() {
    return {
      email: "",
      document: "",
      unique_id: "",
      password: "",
      keepLogged: false,
      loading: false,
      supported_emails: [],
      loginType: "matricula",
    };
  },
  computed: {
    canSubmit() {
      return (
        ((this.loginType == "email" && this.$helpers.isEmail(this.email)) ||
          (this.loginType == "cpf" && this.$helpers.isCPF(this.document)) ||
          (this.loginType == "matricula" && this.unique_id.length > 2)) &&
        this.$helpers.validPassword(this.password)
      );
    },
  },
  components: {
    ContentLogin,
    FloatingLabel,
    PencilIcon,
  },
  mounted() {
    this.$store
      .dispatch("user/companyInternalRecruitment", {})
      .then((response) => {
        var data = response.data;

        if (data) {
          var domains = data.companyInternalRecruitment.domains;

          this.loginType = data.companyInternalRecruitment.loginType;

          if (domains.length > 0) {
            this.supported_emails =
              data.companyInternalRecruitment.domains.split(";");
          }
        }
      });
  },
  methods: {
    submit() {
      this.loading = true;
      let current_profile = this.$store.state.deviseTrying;
      current_profile.email = this.email;
      current_profile.document = this.document;
      current_profile.unique_id = this.unique_id;
      current_profile.password = this.password;
      current_profile.keepLogged = this.keepLogged;
      current_profile.provider = null;
      current_profile.id = null;
      this.$store.commit("DEVISE_TRYING", current_profile);
      this.signIn();
    },
    signIn() {
      this.$store.commit("DEVISE_LOADING", true);

      const { email, document, unique_id, password, keepLogged, provider, id } =
        this.$store.state.deviseTrying;

      const params = {
        email: email,
        document: document,
        unique_id: unique_id,
        password: password,
        keepLogged: keepLogged,
        provider: provider,
        provider_id: id,
      };

      if (this.supported_emails.length > 0) {
        const emailDomain = email.split("@");

        if (!this.supported_emails.includes("@" + emailDomain[1])) {
          this.loading = false;
          this.$swal(
            "Uoops",
            "Insira um e-mail " + this.supported_emails.join(" ou "),
            "error"
          );
          this.$store.commit("DEVISE_LOADING", false);
          return;
        }
      }

      this.$store.dispatch("user/employerSignIn", params).then((response) => {
        if (response.error) {
          if (response.error.message.indexOf("Senha") !== -1) {
            var _loginType = this.loginType == "cpf" ? "CPF" : "E-mail";

            this.$swal("Uoops", _loginType + " ou senha incorretos", "error");
            this.$store.commit("DEVISE_LOADING", false);
          } else {
            this.$swal({
              title: "Uoops",
              text: "Não encontramos seu usuário. Deseja se cadastrar?",
              type: "error",
              showCancelButton: true,
              cancelButtonText: "Não",
              confirmButtonText: "Sim, quero me cadastrar",
              reverseButtons: true,
            }).then((result) => {
              if (result.value) {
                this.$router.push("/register");
              }

              this.$store.commit("DEVISE_LOADING", false);
            });
          }
          this.loading = false;
        } else {
          this.$store.commit("DEVISE_LOADING", "complete");

          setTimeout(() => {
            // Tempo para aparecer uma mensagem de complete
            this.$store.commit("DEVISE_FORM", null);
            this.$store.commit("DEVISE_LOADING", false);
            this.$router.push({ name: "home" });
            this.$store.dispatch("user/companyFollow");
            this.$EventBus.$emit("checkTermsOfUse");
            this.loading = false;
          }, 3000);
        }
      });
    },
  },
};
</script>

<template>
  <div class="login">
    <div class="bg-form">
      <div class="logo">
        <img src="@/assets/images/dpsp/logo-dpsp-white.png" alt="" />
      </div>
      <form @submit.prevent="submit">
        <h2><strong>POC - </strong> Programa de oportunidade de carreira</h2>

        <div class="form-group">
          <input
            type="email"
            input-class="form-control form-control-xl bg-color-4 border-0"
            placeholder="E-mail"
            v-model="email"
            v-if="loginType == 'email'"
          />

          <input
            input-class="form-control form-control-xl bg-color-4 border-0"
            placeholder="CPF"
            v-model="document"
            v-mask="'###.###.###-##'"
            v-if="loginType == 'cpf'"
          />

          <input
            input-class="form-control form-control-xl bg-color-4 border-0"
            placeholder="Matrícula"
            v-model="unique_id"
            v-if="loginType == 'matricula'"
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            class="ipt"
            placeholder="Senha"
            label="Senha"
            v-model="password"
          />
        </div>

        <div class="form-group d-flex mb-5">
          <div
            class="
              custom-control
              custom-checkbox
              custom-checkbox-lg
              custom-checkbox-background
            "
          >
            <input
              type="checkbox"
              class="custom-control-input"
              id="keep-logged"
              v-model="keepLogged"
            />
            <label class="custom-control-label" for="keep-logged"
              >Lembrar de mim</label
            >
          </div>

          <div class="d-flex flex-column ml-auto text-right">
            <a
              href="#"
              class="text-primary semi-small"
              @click.prevent="$store.commit('DEVISE_FORM', 'password')"
              >Esqueci minha senha</a
            >
            <!-- <a
                  href="#"
                  class="text-color-3 font-weight-bold semi-small mt-1"
                  @click.prevent="$emit('changeModal', 'forgotUser')"
                  ><u>Esqueci minha Matrícula</u></a
                > -->
          </div>
        </div>

        <div
          class="d-flex align-items-center justify-content-center text-center"
        >
          <button
            type="submit"
            class="btn enter text-white px-4"
            :disabled="!canSubmit"
          >
            <span v-if="!loading"> ACESSAR </span>
            <span v-else> Aguarde... </span>
          </button>
        </div>
      </form>
      <router-link class="account" to="/register"
        >Não possui uma conta?</router-link
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hd {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35%;
  @include media-breakpoint-down(md) {
    display: none;
  }
}

.custom-control-label {
  font-size: 0.9rem;
  color: #000000;
}

.bg-form {
  background-size: auto 100%;
  width: 100%;
  min-height: calc(100vh - 120px);
  @include media-breakpoint-down(md) {
    min-height: calc(100vh - 70px);
  }
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column wrap;
  position: relative;
}
.logo {
  margin-bottom: 1.5rem;
}
.account {
  color: #fff;
  font-size: 0.8rem;
  margin-top: 1rem;
  &:hover {
    text-decoration: underline;
  }
}
.login {
  background-color: theme-color(primary);
  height: auto;
  min-height: 100vh;
  h2 {
    color: #2e3447;
    font-size: 1.3rem !important;
    text-align: center;
    margin-bottom: 2rem;
    font-weight: 400 !important;
    font-family: "Nunito";
    strong {
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #2e3447;
    }
  }
  .container {
    min-height: 100vh;
  }
  form {
    width: 90%;
    max-width: 600px;
    background-color: #fff;
    border-radius: 8px;
    padding: 2.5rem 3.5rem 3.5rem 3.5rem;
    z-index: 99;
    .enter {
      background: #3c83f5 0% 0% no-repeat padding-box;
      border-radius: 32px;
      width: 90%;
      max-width: 333px;
      height: 50px;
      font-size: 1.2rem;
      font-weight: 300;
      margin-top: 1rem;
    }
    .form-group {
      width: 100%;
      max-width: 600px;
    }
    .form-control {
      width: 100%;
      max-width: 625px;
    }
    input {
      width: 100% !important;
      border-radius: 4px !important;
      border: 1px solid #989696 !important;
      height: 50px !important ;
      padding: 0px 1rem;
    }
    input {
      font-size: 1rem !important;
    }
  }
}
</style>